import { supabase } from '../lib/supabase';

export const catalogService = {
  async getAll() {
    const { data, error } = await supabase?.from('catalog_items')?.select('*')?.order('category', { ascending: true })?.order('name', { ascending: true });

    if (error) throw error;

    return data?.map(item => ({
      id: item?.id,
      name: item?.name,
      category: item?.category,
      price: parseFloat(item?.price),
      description: item?.description,
      createdAt: item?.created_at,
      updatedAt: item?.updated_at
    }));
  },

  async searchByName(searchTerm) {
    const { data, error } = await supabase?.from('catalog_items')?.select('*')?.ilike('name', `%${searchTerm}%`)?.order('name', { ascending: true });

    if (error) throw error;

    return data?.map(item => ({
      id: item?.id,
      name: item?.name,
      category: item?.category,
      price: parseFloat(item?.price),
      description: item?.description,
      createdAt: item?.created_at,
      updatedAt: item?.updated_at
    }));
  },

  async getByCategory(category) {
    const { data, error } = await supabase?.from('catalog_items')?.select('*')?.eq('category', category)?.order('name', { ascending: true });

    if (error) throw error;

    return data?.map(item => ({
      id: item?.id,
      name: item?.name,
      category: item?.category,
      price: parseFloat(item?.price),
      description: item?.description,
      createdAt: item?.created_at,
      updatedAt: item?.updated_at
    }));
  }
};